import { Component, type ErrorInfo, type ReactNode } from 'react';
import { capture } from './diagnosticsBoot';

/** A render that throws (qa-runs 1227): recorded with its component stack, and the page says so instead of going blank. */
export class DiagnosticsBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError() { return { failed: true }; }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    capture('client.react', { message: error.message, stack: error.stack, componentStack: info.componentStack });
  }

  override render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main role="alert" className="min-h-screen bg-stone-950 text-stone-100 flex flex-col items-center justify-center gap-3 p-6" data-testid="page-failed">
        <p>Something went wrong on this page.</p>
        <button type="button" className="rounded border border-stone-600 px-3 py-1" onClick={() => window.location.reload()}>Reload</button>
      </main>
    );
  }
}
